// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"96":"e6c6a9caf0f28945","4574":"559d5087eabecc97","6975":"d9a9c1672fe2f313"}[chunkId] + ".css";
};